// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3uBS2","subheader":"ReorderModal_subheader__21ad3","listWrap":"ReorderModal_listWrap__1JPE-"};